import { useGLTF } from '@react-three/drei';
import { useEffect } from 'react';

export function Shadow({ model }) {
  const { nodes, materials } = useGLTF('models/shadow/' + model + '.glb');

  useEffect(() => {
    if (materials.shadow_catcher) {
      materials.shadow_catcher.roughness = 1; // Set roughness to 1
      materials.shadow_catcher.opacity = 0.2; // Set opacity to 0.5
      materials.shadow_catcher.transparent = true; // Ensure transparency is enabled
    }
  }, [materials, nodes]);

  return (
    <group name={'Mainecottage'} dispose={null}>
      <mesh
        castShadow
        geometry={nodes.shadow_catcher.geometry}
        material={materials.shadow_catcher}
        position={[0, 0.0040, 0]}
      />
    </group>
  );
}
